import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { workoutAPI } from '../services/workoutAPI';

function StartProgramModal({ program, onClose, onSuccess }) {
  const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
  const [isStarting, setIsStarting] = useState(false);
  const [error, setError] = useState(null);

  const handleStart = async () => {
    setError(null);
    setIsStarting(true);

    try {
      // Copy the program first
      const copyResult = await workoutAPI.copyProgram(program.id);

      // Start the copied program with selected start date
      await workoutAPI.startProgram(copyResult.program_id, startDate);

      onSuccess();
      onClose();
    } catch (err) {
      console.error('Error starting program:', err);
      setError('Failed to start program. Please try again.');
    } finally {
      setIsStarting(false);
    }
  };

  return (
    <Modal show onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Start Program</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        <p className="mb-3">
          <strong>Program:</strong> {program.name}
        </p>

        <Alert variant="info" className="mb-3">
          <i className="fas fa-info-circle me-2"></i>
          Choose when you want to start this program. Day 1 will be scheduled for this date.
        </Alert>

        <Form.Group>
          <Form.Label>Start Date (Day 1)</Form.Label>
          <Form.Control
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            disabled={isStarting}
          />
          <Form.Text className="text-muted">
            All workout dates will be calculated from this start date.
          </Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={isStarting}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleStart} disabled={isStarting || !startDate}>
          {isStarting ? (
            <>
              <i className="fas fa-spinner fa-spin me-2"></i>
              Starting...
            </>
          ) : (
            <>
              <i className="fas fa-play-circle me-2"></i>
              Start Program
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default StartProgramModal;
